import React from 'react';
import { Link, withRouter } from 'react-router';
import './index.scss';
import cn from 'classnames';
import { compose } from 'redux';

/**
 * VerticalPerformanceDetails
 * Display the list of students associated with each performance level category vertically.
 */

const VerticalPerformanceDetails = ({ stacks, studentUrl, ariaId, router }) => {
  const { subject, assignmentId } = router.params;

  const studentRedirectionUrl =
    studentUrl || `/${subject}/assessments/results/${assignmentId}/students`;

  return (
    <div id={ariaId} className="vertical-performance-details">
      {stacks.map((stack) =>
        stack.students.map((student) => (
          <div className="student" key={student.id}>
            <div className={cn('status-bar', stack.status)} />
            {studentRedirectionUrl ? (
              <Link
                tabIndex={0}
                aria-label={`${stack.type}, ${stack.label} : ${student.firstName} ${student.lastName}`}
                className="student-name"
                to={`${studentRedirectionUrl}/${student.id}`}
              >
                {student.firstName} {student.lastName}
              </Link>
            ) : (
              <span
                aria-label={`${stack.type}, ${stack.label} : ${student.firstName} ${student.lastName}`}
                className="student-name student-name__disabled"
              >
                {student.firstName} {student.lastName}
              </span>
            )}
          </div>
        )),
      )}
    </div>
  );
};

export default compose(withRouter)(VerticalPerformanceDetails);
